import { Endpoints } from '@/core/models/endpoints.interface';
interface ShiftEndpoints extends Pick<Endpoints, 'GET_ALL'> {
   DELETE_BULK: () => string;
   POST_BULK: () => string;
   PREDICT: () => string;
   PREDICT_BULK: () => string;
   PUT_BULK: () => string;
}

export const SHIFT_ENDPOINTS: ShiftEndpoints = {
   DELETE_BULK: () => `shift/bulk`,
   GET_ALL: () => `shift`,
   POST_BULK: () => `shift/bulk`,
   PREDICT: () => `shift/predict`,
   PREDICT_BULK: () => `shift/bulk-predict`,
   PUT_BULK: () => `shift/bulk`,
};
